<!-- 导航 -->
<template>
  <Transition name="fade">
    <div
      v-if="nav"
      class="fix fade-element"
      @click="showNav(false)"
    >
    </div>
  </Transition>
  <Transition name="fade">
    <div
      v-if="nav"
      class="nav top-move fade-element gw"
      :class="[XhLang, activityEnd?'activityEnd':'']"
    >
      <div
        class="close"
        @click="showNav(false)"
      ></div>
      <!-- 菜单 -->
      <ul v-if="activityEnd">
        <li
          @click="showNav(false)"
          v-if="getSystem() =='iOS'"
        >
          <a
            :href="store.state.articlesData.doubleStore"
            target="_blank"
            class="market_download_above"
          ></a>
        </li>
        <li
          @click="showNav(false)"
          v-else
        >
          <a
            :href="store.state.articlesData.googlePlay"
            target="_blank"
          ></a>
        </li>
        <li @click="showNav(false)">
          <a
            :href="store.state.articlesData.payUrl"
            class="market_pay_above"
            target="_blank"
          ></a>
        </li>
        <li @click="showNav(false)">
          <a
            href="#"
            @click.prevent="scrollToSpecificHeight(600)"
          ></a>
        </li>
        <li @click="showNav(false)">
          <a
            href="#"
            @click.prevent="scrollToSpecificHeight(1200)"
          ></a>
        </li>
      </ul>
      <ul v-else>
        <li>
          <router-link
            to="/pre"
            class="market_phone_above"
          ></router-link>
        </li>
        <li>
          <a
            :href="store.state.articlesData['fbPage' + XhLang.toUpperCase()]"
            v-bind:key="index"
            target="_blank"
            class="'market_FBdraw_above'"
          >
          </a>
        </li>
        <li @click="showNav(false)">
          <a
            href="#"
            @click.prevent="scrollToSpecificHeight(600)"
          ></a>
        </li>
        <li @click="showNav(false)">
          <a
            href="#"
            @click.prevent="scrollToSpecificHeight(1200)"
          ></a>
        </li>
      </ul>
      <!-- 分享 -->
      <div class="share">
        <a
          :href="store.state.articlesData['fbPage' + XhLang.toUpperCase()]"
          v-bind:key="index"
          target="_blank"
        >
          <img
            class="'market_FBdraw_above'"
            src="../../../assets/images/fb.png"
          />
        </a>
        <a
          :href="store.state.articlesData.discordShare"
          target="_blank"
        >
          <img
            class="'market_DC_above'"
            src="../../../assets/images/dc.png"
          >
        </a>
        <a @click="fillUpShare(ShareData)">
          <img
            :class="'market_FB_jump'"
            src="../../../assets/images/line.png"
          >
        </a>
      </div>
      <!-- 语言 -->
      <div class="lang">
        <p
          :class="XhLang =='cn' ? 'active':''"
          @click="changeLanguage('cn', 'cn_TW')"
        >CN</p>
        /
        <p
          :class="XhLang =='en' ? 'active':''"
          @click="changeLanguage('en', 'en_US')"
        >EN</p>
        /
        <p
          :class="XhLang =='th' ? 'active':''"
          @click="changeLanguage('th', 'th_TH')"
        >TH</p>
      </div>
    </div>
  </Transition>
  <div
    class="nav_btn"
    :class="[deviceType(), position]"
    @click="showNav()"
  >
  </div>

</template>

<script setup>
import { defineProps, ref } from "vue";
import { useI18n } from "vue-i18n";
import { shareFB } from "@/util/share";
import { getSystem, deviceType, scrollToSpecificHeight } from "@/util/base";
import { xhSet } from "@/util/xhCookie";
import { useStore } from "vuex";
const store = useStore();

defineProps(["ShareData", "position", "activityEnd"]);
const { locale } = useI18n();
const XhLang = locale.value;
const nav = ref(false);
const slide = ref(true);

const showNav = (type) => {
  nav.value = type !== undefined ? type : !nav.value;
};

// 切换语言
const changeLanguage = (langName, fb_lang) => {
  xhSet("XH-WEB", {
    page_lang: langName,
    fb_lang: fb_lang,
  });
  location.reload();
};

const scrollToTop = () => {
  const scrollTops =
    document.documentElement.scrollHeight / document.documentElement.scrollTop;
  if (scrollTops < 4.5 && deviceType() == "pc") {
    slide.value = false;
  } else {
    slide.value = true;
  }
};
window.addEventListener("scroll", scrollToTop);

const fillUpShare = (data) => {
  const shareLink = window.location.href;
  let shareTitle = "";
  let shareImg = "";
  for (const item of data) {
    if (item.label === "shareTitle") {
      shareTitle = item.content;
    }
    if (item.label === "shareImg") {
      shareImg = item.content;
    }
  }
  shareFB(shareLink, shareTitle, shareImg);
};
</script>


<style lang='scss' scoped>
.nav_btn {
  position: fixed;
  right: 0.15rem;
  top: 0.15rem;
  width: 0.87rem;
  height: 0.93rem;
  background: url("../../../assets/images/nav.png") no-repeat center top;
  background-size: 100% auto;
  z-index: 1000;
  cursor: pointer;
  &.wap {
    width: 0.9rem;
    height: 0.96rem;
  }
  &.gwwap {
    width: 0.65rem;
    height: 0.65rem;
    right: 0.15rem;
    top: 0.2rem;
    background: url("../../../assets/images/nav2.png") no-repeat center top;
    background-size: 100% auto;
  }
}
.nav {
  position: fixed;
  z-index: 1002;
  width: 4.27rem;
  height: 7.33rem;
  top: 0.15rem;
  right: 0;

  &.en {
    background: url("../../../assets/images/en/nav-info.png") no-repeat center;
    background-size: 100% auto;
  }
  &.th {
    background: url("../../../assets/images/th/nav-info.png") no-repeat center;
    background-size: 100% auto;
  }
  &.cn {
    background: url("../../../assets/images/cn/nav-info.png") no-repeat center;
    background-size: 100% auto;
  }

  &.gw.activityEnd {
    &.en {
      background: url("../../../assets/images/en/gw-nav-info.png") no-repeat
        center;
      background-size: 100% auto;
    }
    &.th {
      background: url("../../../assets/images/th/gw-nav-info.png") no-repeat
        center;
      background-size: 100% auto;
    }
    &.cn {
      background: url("../../../assets/images/cn/gw-nav-info.png") no-repeat
        center;
      background-size: 100% auto;
    }
  }

  &.gw {
    &.en {
      background: url("../../../assets/images/en/nav-info.png") no-repeat center;
      background-size: 100% auto;
    }
    &.th {
      background: url("../../../assets/images/th/nav-info.png") no-repeat center;
      background-size: 100% auto;
    }
    &.cn {
      background: url("../../../assets/images/cn/nav-info.png") no-repeat center;
      background-size: 100% auto;
    }
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.5rem;
    height: 0.5rem;
    cursor: pointer;
  }
  ul {
    margin-top: 1.75rem;
    font-size: 0.3rem;
    height: 3.75rem;
    li {
      cursor: pointer;
      text-align: center;
      color: #ffe98c;
      text-shadow: #333333 2px 1px 1px;
      line-height: 0.93rem;
      height: 0.93rem;
      a {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.25rem 0;
    height: 0.72rem;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.7rem;
        margin: 0 0.2rem;
      }
    }
  }
  .lang {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.18rem;
    background: #baf0e7;
    margin: 0 auto;
    border: 1px solid #2588b0;
    border-radius: 0.1rem;
    line-height: 0;
    p {
      margin: 0 0.12rem;
      line-height: 0.3rem;
      color: #375c6b;
      cursor: pointer;
      &.active {
        font-weight: bold;
      }
    }
  }
}
</style>
